import Cookies from 'js-cookie'

import { getConfigBySite } from '../../../config/sites'
import ga from '../../../common/utils/ga'

/**
 * check if a site has only one avaiable layout
 * @param {String} siteName
 */
const hasOnlyOneLayout = siteName => {
  const itemViewsConfig = getConfigBySite(siteName, 'ui.item_list_views') || []
  return itemViewsConfig.length === 1
}

/**
 * read the default view type from config
 * @param  {String} currentSite
 * @return {String} the final view type we use
 */
export const getDefaultViewTypeBySite = currentSite =>
  getConfigBySite(currentSite, 'item_results_layout')

export const initClientUserSearchResultsViewType = location => {
  return (dispatch, getState) => {
    const currentSite = getState().common.currentSite
    const defaultSiteViewType = getDefaultViewTypeBySite(currentSite)

    if (hasOnlyOneLayout(currentSite)) {
      dispatch(setUserSearchResultsViewType(defaultSiteViewType))
    } else if (location && location.query.view) {
      // if there is view parameter for initial rendering, save view type to cookie
      dispatch(setUserSearchResultsViewType(location.query.view))
    } else {
      // read from cookie
      let view = Cookies.get('search-view-mode-preference')
      // override default view type if there's preference in cookie
      if (view) {
        dispatch(setUserSearchResultsViewType(view))
      } else {
        ga('send', 'event', 'product list', 'display', defaultSiteViewType, {
          nonInteraction: true
        })
      }
    }
  }
}

export const initServerUserSearchResultsViewType = location => {
  return (dispatch, getState) => {
    const currentSite = getState().common.currentSite
    const defaultSiteViewType = getDefaultViewTypeBySite(currentSite)

    if (hasOnlyOneLayout(currentSite)) {
      dispatch(setServerUserSearchResultsViewType(defaultSiteViewType))
    } else if (location && location.query.view) {
      // if there is view parameter for initial rendering, set view type to cookie
      dispatch(setServerUserSearchResultsViewType(location.query.view))
    } else {
      // otherwise read from the default config
      dispatch(setServerUserSearchResultsViewType(defaultSiteViewType))
    }
  }
}

export const setUserSearchResultsViewType = nextView => {
  Cookies.set('search-view-mode-preference', nextView)
  ga('send', 'event', 'product list', 'display', nextView, {
    nonInteraction: true
  })
  return { type: 'setUserSearchResultsViewType', payload: { view: nextView } }
}

export const setServerUserSearchResultsViewType = nextView => {
  return { type: 'setUserSearchResultsViewType', payload: { view: nextView } }
}

export const setUserVideoPlayerStatus = type => {
  return {
    type: 'setUserVideoPlayerStatus',
    payload: { type }
  }
}

export const setUserVideoAutoPlayStatus = status => {
  return {
    type: 'setUserVideoAutoPlayStatus',
    payload: status
  }
}

export const setUserAudioVolumeLevel = level => {
  return {
    type: 'setUserAudioVolumeLevel',
    payload: { level }
  }
}

export const setUserAudioMuteStatus = status => {
  return {
    type: 'setUserAudioMuteStatus',
    payload: status
  }
}
